import React, { useState } from 'react';
import {
  Search, Eye, Ban, Shield, AlertTriangle,
  Phone, MapPin, Calendar, X, Mail, UserX, SearchX
} from 'lucide-react';
import '../../../../assets/css/screens/admin/dashboard/reportedcustomers/Reportedcustomers.css';

// ── Data ─────────────────────────────────────────────────────
const CUSTOMERS = [
  {
    id: 1,
    initials: 'BS',
    name: 'Bilal Shah',
    email: 'bilal@mail.com',
    phone: '+92 333 9876543',
    city: 'Lahore',
    joined: 'Dec 20, 2025',
    reportedBy: 'Ali Electrician',
    reason: 'Abusive language and refused to pay after service completion',
    reports: 4,
    status: 'Blocked',
    latestReport: {
      by: 'Ali Electrician',
      message: 'Abusive language and refused to pay after service completion',
      date: 'Mar 20, 2026',
    },
  },
  {
    id: 2,
    initials: 'ZM',
    name: 'Zain Malik',
    email: 'zain@mail.com',
    phone: '+92 301 1234567',
    city: 'Karachi',
    joined: 'Jan 10, 2026',
    reportedBy: 'Usman Plumber',
    reason: 'Provided fake address and wasted provider time',
    reports: 2,
    status: 'Under Review',
    latestReport: {
      by: 'Usman Plumber',
      message: 'Provided fake address and wasted provider time on multiple occasions',
      date: 'Mar 18, 2026',
    },
  },
  {
    id: 3,
    initials: 'HR',
    name: 'Hamza Raza',
    email: 'hamza@mail.com',
    phone: '+92 302 9988776',
    city: 'Islamabad',
    joined: 'Feb 5, 2026',
    reportedBy: 'Hassan AC Expert',
    reason: 'Harassment and threats to provider',
    reports: 3,
    status: 'Under Review',
    latestReport: {
      by: 'Hassan AC Expert',
      message: 'Harassment and threats to provider during and after service visit',
      date: 'Mar 15, 2026',
    },
  },
  {
    id: 4,
    initials: 'FS',
    name: 'Farhan Saeed',
    email: 'farhan@mail.com',
    phone: '+92 303 5544332',
    city: 'Faisalabad',
    joined: 'Nov 28, 2025',
    reportedBy: 'Kashif Painter',
    reason: 'Repeatedly cancels bookings last minute',
    reports: 5,
    status: 'Warning Issued',
    latestReport: {
      by: 'Kashif Painter',
      message: 'Repeatedly cancels bookings at the last minute causing financial loss',
      date: 'Mar 22, 2026',
    },
  },
  {
    id: 5,
    initials: 'IA',
    name: 'Imran Ali',
    email: 'imran@mail.com',
    phone: '+92 304 7766554',
    city: 'Multan',
    joined: 'Mar 1, 2026',
    reportedBy: 'Kamran Cleaner',
    reason: 'Payment dispute - claimed service not done',
    reports: 1,
    status: 'Under Review',
    latestReport: {
      by: 'Kamran Cleaner',
      message: 'Payment dispute - customer claimed service was not done despite completion',
      date: 'Mar 25, 2026',
    },
  },
];

const STATUS_TABS = ['All', 'Under Review', 'Warning Issued', 'Blocked'];

const STATUS_CFG = {
  'Blocked':       { cls: 'rc-badge--blocked',  label: 'Blocked'       },
  'Under Review':  { cls: 'rc-badge--review',   label: 'Under Review'  },
  'Warning Issued':{ cls: 'rc-badge--warning',  label: 'Warning Issued'},
};

const REPORT_CFG = {
  1: 'rc-reports--low',
  2: 'rc-reports--low',
  3: 'rc-reports--mid',
  4: 'rc-reports--high',
  5: 'rc-reports--high',
};

// ── Detail Modal ──────────────────────────────────────────────
const DetailModal = ({ customer: c, onClose }) => {
  if (!c) return null;
  const st = STATUS_CFG[c.status] || STATUS_CFG['Under Review'];

  return (
    <div className="rc-modal-overlay" onClick={onClose}>
      <div className="rc-modal" onClick={e => e.stopPropagation()}>

        <button className="rc-modal-close" onClick={onClose}><X size={18} /></button>

        <h5 className="rc-modal-title">Customer Report Details</h5>

        {/* Profile row */}
        <div className="rc-modal-profile">
          <div className="rc-modal-avatar">{c.initials}</div>
          <div className="rc-modal-profile-info">
            <p className="rc-modal-name">{c.name}</p>
            <span className="rc-modal-email">{c.email}</span>
          </div>
          <span className={`rc-badge ${st.cls}`}>{st.label}</span>
        </div>

        {/* Info grid */}
        <div className="rc-modal-grid">
          <div className="rc-modal-cell">
            <span className="rc-modal-cell-icon"><Phone size={14} /></span>
            <div>
              <span className="rc-modal-cell-lbl">Phone</span>
              <strong className="rc-modal-cell-val">{c.phone}</strong>
            </div>
          </div>
          <div className="rc-modal-cell">
            <span className="rc-modal-cell-icon"><MapPin size={14} /></span>
            <div>
              <span className="rc-modal-cell-lbl">City</span>
              <strong className="rc-modal-cell-val">{c.city}</strong>
            </div>
          </div>
          <div className="rc-modal-cell">
            <span className="rc-modal-cell-icon"><Calendar size={14} /></span>
            <div>
              <span className="rc-modal-cell-lbl">Joined</span>
              <strong className="rc-modal-cell-val">{c.joined}</strong>
            </div>
          </div>
          <div className="rc-modal-cell">
            <span className="rc-modal-cell-icon rc-modal-cell-icon--red"><AlertTriangle size={14} /></span>
            <div>
              <span className="rc-modal-cell-lbl">Total Reports</span>
              <strong className="rc-modal-cell-val rc-modal-cell-val--red">{c.reports}</strong>
            </div>
          </div>
        </div>

        {/* Latest report */}
        <div className="rc-modal-report">
          <p className="rc-modal-report-by">Latest Report by {c.latestReport.by}</p>
          <p className="rc-modal-report-msg">{c.latestReport.message}</p>
          <span className="rc-modal-report-date">{c.latestReport.date}</span>
        </div>

        {/* Actions */}
        <div className="rc-modal-actions">
          <button className="rc-modal-warn-btn">
            <Mail size={15} /> Send Warning
          </button>
          <button className="rc-modal-block-btn">
            <Ban size={15} /> Block User
          </button>
        </div>

      </div>
    </div>
  );
};


// ── Main Page ─────────────────────────────────────────────────
const ReportedCustomers = () => {
  const [activeTab,    setActiveTab]    = useState('All');
  const [search,       setSearch]       = useState('');
  const [selected,     setSelected]     = useState(null);

  // Filter
  const filtered = CUSTOMERS.filter(c => {
    const matchTab = activeTab === 'All' || c.status === activeTab;
    const q = search.toLowerCase();
    const matchSearch =
      c.name.toLowerCase().includes(q)  ||
      c.email.toLowerCase().includes(q) ||
      c.reportedBy.toLowerCase().includes(q);
    return matchTab && matchSearch;
  });

  const hasSearch = search.trim().length > 0;

  return (
    <div className="rc-page">

      {/* ── Page Header ── */}
      <div className="rc-page-header">
        <div className="rc-page-header-left">
          <div className="rc-page-heading-row">
            <Shield size={22} className="rc-page-shield" />
            <h2 className="rc-page-title">Reported Customers</h2>
          </div>
          <p className="rc-page-sub">
            {CUSTOMERS.length > 0
              ? `Manage and review customers reported by service providers`
              : 'No customers have been reported yet'}
          </p>
        </div>
        <div className="rc-search-box">
          <Search size={15} className="rc-search-icon" />
          <input
            type="text"
            className="rc-search-input"
            placeholder="Search by name or email..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* ── Tabs ── */}
      <div className="rc-tabs">
        {STATUS_TABS.map(tab => (
          <button
            key={tab}
            className={`rc-tab${activeTab === tab ? ' rc-tab--active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ════ EMPTY: no data at all ════ */}
      {CUSTOMERS.length === 0 && (
        <div className="rc-empty">
          <div className="rc-empty-icon-wrap">
            <UserX size={36} className="rc-empty-icon" />
          </div>
          <h5 className="rc-empty-title">No Reported Customers</h5>
          <p className="rc-empty-desc">
            Great news! No customers have been reported by service providers yet.
            This page will show reported customers when they appear.
          </p>
        </div>
      )}

      {/* ════ EMPTY: search not found ════ */}
      {CUSTOMERS.length > 0 && filtered.length === 0 && (
        <div className="rc-empty">
          <div className="rc-empty-icon-wrap">
            <SearchX size={36} className="rc-empty-icon" />
          </div>
          <h5 className="rc-empty-title">No matching customers found</h5>
          <p className="rc-empty-desc">
            We couldn't find any reported customers matching
            {hasSearch && <> "{search}".</>} Try a different search term.
          </p>
          {hasSearch && (
            <button className="rc-clear-btn" onClick={() => setSearch('')}>
              <Search size={14} /> Clear Search
            </button>
          )}
        </div>
      )}

      {/* ════ TABLE ════ */}
      {filtered.length > 0 && (
        <div className="rc-table-wrap">
          <table className="rc-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Reported By</th>
                <th>Reason</th>
                <th>Reports</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, i) => {
                const st  = STATUS_CFG[c.status] || STATUS_CFG['Under Review'];
                const rCls = REPORT_CFG[c.reports] || 'rc-reports--high';
                return (
                  <tr key={c.id} style={{ animationDelay: `${i * 0.05}s` }}>
                    {/* Customer */}
                    <td>
                      <div className="rc-customer-cell">
                        <div className="rc-avatar">{c.initials}</div>
                        <div>
                          <p className="rc-cust-name">{c.name}</p>
                          <span className="rc-cust-email">{c.email}</span>
                        </div>
                      </div>
                    </td>
                    {/* Reported By */}
                    <td className="rc-td-muted">{c.reportedBy}</td>
                    {/* Reason */}
                    <td className="rc-td-reason">
                      {c.reason.length > 30 ? c.reason.slice(0, 30) + '…' : c.reason}
                    </td>
                    {/* Reports count */}
                    <td>
                      <span className={`rc-reports ${rCls}`}>{c.reports}</span>
                    </td>
                    {/* Status */}
                    <td>
                      <span className={`rc-badge ${st.cls}`}>{st.label}</span>
                    </td>
                    {/* Actions */}
                    <td>
                      <div className="rc-actions">
                        <button
                          className="rc-action-btn rc-action-btn--view"
                          title="View Details"
                          onClick={() => setSelected(c)}
                        >
                          <Eye size={17} />
                        </button>
                        <button
                          className="rc-action-btn rc-action-btn--block"
                          title="Block"
                        >
                          <Ban size={17} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Modal ── */}
      {selected && (
        <DetailModal customer={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
};

export default ReportedCustomers;